var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.5625,
    y: 13,
    width: 10,
    height: 3,
    fill: "#001B3D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.46037 1.05793C9.74562 0.980692 10.0463 0.980692 10.3315 1.05793C10.6627 1.14758 10.9415 1.36647 11.164 1.54116L11.2262 1.58983L16.8781 5.98577L16.9428 6.03606C17.2567 6.27963 17.5332 6.49422 17.7392 6.7728C17.9201 7.01729 18.0548 7.29271 18.1367 7.58555C18.2301 7.91922 18.2298 8.26923 18.2293 8.6665L18.2293 8.74851V14.8098V14.8098V14.8098C18.2293 15.2491 18.2293 15.628 18.2038 15.9401C18.1769 16.2696 18.1175 16.5973 17.9568 16.9126C17.7171 17.383 17.3347 17.7654 16.8643 18.0051C16.5489 18.1658 16.2213 18.2252 15.8918 18.2521C15.5797 18.2776 15.2007 18.2776 14.7615 18.2776H14.7614H14.7614H5.03048H5.03046H5.03043C4.59117 18.2776 4.21222 18.2776 3.90009 18.2521C3.57064 18.2252 3.24296 18.1658 2.92764 18.0051C2.45723 17.7654 2.07478 17.383 1.8351 16.9126C1.67444 16.5973 1.61501 16.2696 1.58809 15.9401C1.56259 15.628 1.5626 15.249 1.56262 14.8097L1.56262 8.74851L1.56256 8.66652C1.56213 8.26924 1.56175 7.91923 1.65515 7.58555C1.73712 7.29271 1.87182 7.01729 2.05265 6.7728C2.2587 6.49422 2.53521 6.27963 2.84907 6.03606L2.91382 5.98577L8.56575 1.58983L8.62793 1.54116C8.85044 1.36647 9.12923 1.14758 9.46037 1.05793ZM6.56265 13.2776C6.10241 13.2776 5.72931 13.6507 5.72931 14.111C5.72931 14.5712 6.10241 14.9443 6.56265 14.9443H13.2293C13.6896 14.9443 14.0626 14.5712 14.0626 14.111C14.0626 13.6507 13.6896 13.2776 13.2293 13.2776H6.56265Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.97af384a20fbc8f0bf49c50b0cdb83ee.svg";
export { ForwardRef as ReactComponent };